import { PlatformType } from '../constants/common';
export var OSType;
(function (OSType) {
    OSType["iOS"] = "iOS";
    OSType["Android"] = "Android";
})(OSType || (OSType = {}));
export var AppType;
(function (AppType) {
    AppType["Tools"] = "tools";
    AppType["Homepage"] = "homepage";
    AppType["App"] = "app";
})(AppType || (AppType = {}));
